/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const tractor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.933 8.73C8.086 7.498 6.694 6.67 5.178 6.5a5.403 5.403 0 0 0-2.546.337M1 7.842a5.24 5.24 0 0 1 1.632-1.005m11.434 4.425c.563.366.934.99.934 1.697C15 14.086 14.06 15 12.9 15c-1.081 0-1.972-.794-2.088-1.814m3.255-1.924a2.134 2.134 0 0 0-1.167-.343c-1.236 0-2.223 1.08-2.088 2.267m3.255-1.924V8.43a.931.931 0 0 0-.679-.872l-4.781-.72-.92-3.48h.623C8.31 3.03 8.445 2 7.912 2H3.418c-.532 0-.397 1.031-.397 1.356h.622l-1.01 3.481m4.896 6.35A3.276 3.276 0 0 1 4.577 15c-1.804 0-3.267-1.421-3.267-3.174 0-1.754 1.463-3.175 3.267-3.175 1.804 0 3.267 1.421 3.267 3.175 0 .487-.113.949-.315 1.362Zm0 0h3.283"
    />
  </svg>
)
export default tractor
